import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";

export const arrowRight = ({ size = 15, color = "black", sx }) => {
  return <KeyboardArrowRightRoundedIcon sx={{ color, mr: "0.08rem", ...sx }} />;
};
